import { cn } from '@/helpers/utils'
import { useTranslation } from '@/translations/i18n'
import { STATUS_STYLES } from '../constants'
import { ROADMAP_ACTIVITY_STATUS_OPTIONS } from '../types'

function RoadmapLegend() {
	const { t } = useTranslation()

	return (
		<div className='flex flex-wrap items-center gap-4'>
			<span className='font-medium text-neutral-700 text-xs'>
				{t('roadmaps:legend_label')}
			</span>
			{ROADMAP_ACTIVITY_STATUS_OPTIONS.map((status) => (
				<div className='flex items-center gap-1.5' key={status}>
					{/* The swatch wears the bar's own classes, so it is the same
					    colour by construction rather than by a copied hex. */}
					<span
						className={cn(
							'size-3 shrink-0 rounded-sm border',
							STATUS_STYLES[status].bar
						)}
					/>
					<span className='text-neutral-700 text-xs'>
						{t(STATUS_STYLES[status].label)}
					</span>
				</div>
			))}
		</div>
	)
}

export { RoadmapLegend }
